// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

// /* axios */
// import axios from './api'
// import api from './api/api'
// Vue.prototype.http = axios;
// Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

import './assets/css/new.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

// i18n
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages: {
    'zh': require('./i18n/lang/zh'),
    'en': require('./i18n/lang/en')
  }
})


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  const routeTitleMap = {
    '/home': 'RouteTitleHome',
    '/project_CharterShip': 'RouteTitleCharterShip',
    '/CharterShip_info': 'RouteTitleCharterShipInfo',
    '/project_CharterPlane': 'RouteTitleCharterPlane',
    '/project_Russia': 'RouteTitleRussiaProject',
    '/CharterPlane_info': 'RouteTitleCharterPlaneInfo',
    '/Project_ElectronicCigarette': 'RouteTitleElectronicCigarette',
    '/Projct_Engineering': 'RouteTitleEngineering',
    '/Projct_semiconductor': 'RouteTitleSemiconductor',
    '/Projct_Personalbelongings': 'RouteTitlePersonalbelongings',
    '/service_BondedPage': 'RouteTitleBonded',
    '/service_Plane': 'RouteTitlePlane',
    '/service_Warehouse': 'RouteTitleWarehouse',
    '/service_Supply': 'RouteTitleSupply',
    '/service_CrossBorder': 'RouteTitleCrossBorder',
    '/project_Childpage': 'RouteTitleProject',
    '/newsPage': 'RouteTitleNews',
    '/newsPage_info': 'RouteTitleNewsInfo',
    '/newsinformation': 'RouteTitleNews',
    '/companyintroduction': 'RouteTitleAbout',
    '/joinUs': 'RouteTitleJoinUs',
    '/jobchance': 'RouteTitleJobChance',
    '/contactus': 'RouteTitleContactUs',
    '/servicedetail': 'RouteTitleServiceDetail',
  }
  const titleKey = routeTitleMap[to.path]
  if (titleKey) {
    document.title = i18n.t(titleKey)
  } else if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});


new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})
